import { render, staticRenderFns } from "./headerCourse.vue?vue&type=template&id=475d09ac&"
import script from "./headerCourse.vue?vue&type=script&lang=js&"
export * from "./headerCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports